import { ShieldZap } from "@untitledui/icons";
import { PageHeader } from "@/pages/admin/page-header";
import { AdminFlagQaTable } from "@/pages/admin/tables/flag-qa";

export const RiskFlagsPage = () => {
  return (
    <div className="h-full flex flex-col gap-6 mt-4 px-12">
      <PageHeader
        title="Content Safety"
        subtitle="Monitor AI risk detection and model accuracy across videos"
        icon={ShieldZap}
      />
      <div className="flex-1 min-h-0 flex flex-col overflow-auto">
        <AdminFlagQaTable />
      </div>
    </div>
  );
};
